import {
  Checkbox,
  Flex,
  FormControl,
  FormErrorMessage,
  IconButton,
  Image,
  InputGroup,
  InputRightElement,
  Spinner,
} from "@chakra-ui/react";
import {
  LinkText,
  //StyledCheckboxText,
  //StyledInputField,
  AuthFormContainer,
  AuthCardEllipse,
  AuthCardTopFrame,
  AuthHeading,
  AuthSubheading,
  AuthFieldsWrapper,
  AuthInputBox,
  AuthInputField,
  AuthLabelText,
  AuthButton,
  AuthButtonWrapper,
  AuthLinkText,
  AuthCheckboxText,
  AddNoticeButton,
} from "@root/commonStyles/commonStyle";
//import { PasswordInput } from "@root/components/common/passwordInput/passwordInput";
import { ROUTE_NAMES, USER_TYPES } from "@root/constants";
import { login } from "@store/thunks";
import { Field, Formik } from "formik";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
//import ReCAPTCHA from "react-google-recaptcha";

import { CloseEye, OpenEye } from "@root/assets/admin";
import { useGlobalContext } from "@root/context/global-context";
import { useOrganizationBranding } from "@root/context/organization-branding-context";

interface LoginValues {
  email: string;
  password: string;
  rememberMe: boolean;
}

export const Login: React.FC = () => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  // const [captchaToken, setCaptchaToken] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { getUserData } = useGlobalContext();
  const {
    logoUrl,
    defaultLogoUrl,
    loading: brandingLoading,
  } = useOrganizationBranding();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const initialValues = {
    email: "",
    password: "",
    rememberMe: false,
  };
  const validate = (values: LoginValues) => {
    const errors: Partial<LoginValues> = {};

    if (!values.password) {
      errors.password = t("login.requiredPassword");
    } else if (values.password.length < 6) {
      errors.password = t("login.passwordValidation");
    }
    return errors;
  };
  // Shift Admin here
  const onSuccess = (res: any) => {
    console.log("res here", res);
    if (!res?.accessToken) {
      return;
    }

    // Fetch complete user profile including avatar (non-blocking)
    getUserData().catch((error: any) => {
      console.error("Failed to fetch user data after login:", error);
    });

    setLoading(false);
    if (res?.user?.role === USER_TYPES.SUPER_ADMIN)
      navigate(ROUTE_NAMES.SUPER_ADMIN_DASHBOARD);
    // if (res?.user?.roleId === USER_TYPES.ADMIN) {
    //   navigate(ROUTE_NAMES.ADMIN_USERS_MANAGMENT);
    // } else {
    //   navigate(ROUTE_NAMES.DASHBOARD);
    // }
  };
  const onError = () => {
    setLoading(false);
  };

  const onSubmit = (values: any) => {
    setLoading(true);
    try {
      const payload = {
        password: values.password.trim(),
        email: values.email.trim(),
      };
      dispatch(
        login({
          payload,
          onSuccess,
          onError,
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  // const handleCaptchaChange = (token: string | null) => {
  //   setCaptchaToken(token);
  // };

  return (
    <>
      <AuthFormContainer>
        <AuthCardEllipse />
        <AuthCardTopFrame>
          <Flex align="center" gap="12.8px" minH="38px">
            {brandingLoading ? (
              <Spinner size="md" />
            ) : (
              <Image
                src={logoUrl || defaultLogoUrl}
                alt="logo"
                maxH="38px"
                objectFit="contain"
              />
            )}
            {/* <NounCube width={32} height={32} /> */}
            {/* <KpecLogoText>{t("login.title")}</KpecLogoText> */}
          </Flex>
          <Flex direction="column" align="stretch" width="100%" gap="10px">
            <AuthHeading>{t("login.subTitle")}</AuthHeading>
            <AuthSubheading>{t("login.subtitle_1")}</AuthSubheading>
          </Flex>
        </AuthCardTopFrame>
        <Formik
          validate={validate}
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, errors, touched, values, setFieldValue }) => (
            <form onSubmit={handleSubmit} style={{ width: "100%" }}>
              <AuthFieldsWrapper>
                <Flex
                  direction="column"
                  align="flex-start"
                  gap="1rem"
                  width="100%"
                >
                  {/* Frame 2.1: ID field */}
                  <Flex
                    direction="column"
                    align="flex-start"
                    gap="0.5rem"
                    width="100%"
                  >
                    <AuthLabelText>{t("login.ID")}</AuthLabelText>
                    <FormControl
                      isInvalid={!!errors.email && touched.email}
                      width="100%"
                    >
                      <AuthInputBox>
                        <AuthInputField
                          id="email"
                          name="email"
                          type="text"
                          required
                          placeholder={t("login.phId")}
                          value={values.email}
                          onChange={(e: React.ChangeEvent<any>) =>
                            setFieldValue("email", e.target.value)
                          }
                        />
                      </AuthInputBox>
                      <FormErrorMessage>{errors.email}</FormErrorMessage>
                    </FormControl>
                  </Flex>
                  {/* Frame 2.2: Password field and actions */}
                  <Flex
                    direction="column"
                    align="flex-start"
                    gap="0.5rem"
                    width="100%"
                  >
                    <AuthLabelText>{t("login.password")}</AuthLabelText>
                    <FormControl
                      isInvalid={!!errors.password && touched.password}
                      width="100%"
                    >
                      <AuthInputBox>
                        <InputGroup>
                          <AuthInputField
                            id="password"
                            name="password"
                            type={showPassword ? "text" : "password"}
                            required
                            placeholder={t("login.phPassword")}
                            value={values.password}
                            onChange={(e: React.ChangeEvent<any>) =>
                              setFieldValue("password", e.target.value.trim())
                            }
                          />
                          <InputRightElement height="100%" alignItems="center">
                            <IconButton
                              aria-label={
                                showPassword
                                  ? t("signup.hidePassword", "Hide password")
                                  : t("signup.showPassword", "Show password")
                              }
                              icon={showPassword ? <CloseEye /> : <OpenEye />}
                              variant="ghost"
                              size="sm"
                              onClick={() => setShowPassword((v) => !v)}
                              _hover={{ background: "transparent" }}
                              tabIndex={-1}
                            />
                          </InputRightElement>
                        </InputGroup>
                      </AuthInputBox>
                      <FormErrorMessage>{errors.password}</FormErrorMessage>
                    </FormControl>
                    {/* Frame 2.2.1: Remember me and Forgot Password */}
                    <Flex justify="space-between" align="center" width="100%">
                      {/* Frame 2.2.1.1: Checkbox and label */}
                      <Flex align="center" gap="0.25rem">
                        <Field
                          colorScheme="purple"
                          as={Checkbox}
                          id="rememberMe"
                          name="rememberMe"
                          width="20px"
                          height="20px"
                        />
                        <AuthCheckboxText>
                          {t("login.remeberMe")}
                        </AuthCheckboxText>
                      </Flex>
                      <AuthLinkText
                        onClick={() => navigate(ROUTE_NAMES.FORGET_PASSWORD)}
                        whiteSpace="nowrap"
                      >
                        {t("login.forgot")}
                      </AuthLinkText>
                    </Flex>
                  </Flex>
                </Flex>
              </AuthFieldsWrapper>
              {/* Button in its own Flex */}
              <AuthButtonWrapper>
                <AuthButton isLoading={loading} type="submit">
                  {t("login.signIn")}
                </AuthButton>
              </AuthButtonWrapper>
            </form>
          )}
        </Formik>
      </AuthFormContainer>
    </>
  );
};
